/* global ContractGroupTeams, CustomFields, Turbo */

import 'lib/custom_fields'
import 'packery/dist/packery.pkgd'
import 'lib/contract_group_teams'
import 'draggabilly/draggabilly'

window['contract_fields#new'] =
  window['contract_fields#edit'] = function () {
    CustomFields.initSelectValues()
  }

window['contract_fields#index'] = function () {
  $(document).off('change', 'input.contract-field-switch')
  $(document).off('change', 'input.custom-contract-group-switch')
  $(document).off('click', '.contract-field-expand')
  new CustomFieldsLayout().initialize()

  ContractGroupTeams.init()
}

class CustomFieldsLayout {
  constructor () {
    /**
     * Usually we find an entity from (candidate, employee, etc.)
     * but here we don't have any type of entity, and use this property like a plug
     */
    this.entity = 'entity'

    this.groupsArea = $('#field-groups')
    this.ungroupedFieldsArea = $('#contract-fields')

    this.getFieldsArea = () => this.groupsArea.find('.draggable-area').add(this.ungroupedFieldsArea)

    this.inactiveGroupsArea = $('#field-groups-inactive')
    this.inactiveFieldsArea = $('#contract-fields-inactive')

    this.fieldDraggableOptions = {
      handle: '.draggable-field > .draggable-handle',
      dragMove: this.__onDragMove.bind(this),
      dragEnd: this.__onDragEnd.bind(this)
    }

    this.groupDraggableOptions = {
      handle: '.draggable-group > .draggable-handle',
      dragEnd: (e) => $(e.target).is(this.groupsArea) && this.__save()
    }
  }

  initialize () {
    this.__bindTogglers()
    // Init Packery on each group draggable area + ungrouped area
    this.__initializePackeryOnFields()

    // Init Packery on groups area
    this.__initializePackeryOnGroups()

    // Init Packery on inactive groups area
    if (this.inactiveGroupsArea.data('packery')) this.inactiveGroupsArea.packery('destroy')
    this.inactiveGroupsArea.packery()

    // Init Packery on inactive fields area
    if (this.inactiveFieldsArea.data('packery')) this.inactiveFieldsArea.packery('destroy')
    this.inactiveFieldsArea.packery()

    this._updateGroupsVisibility()
  }

  __initializePackeryOnFields (elements) {
    if (_.isUndefined(elements)) { elements = this.getFieldsArea() }

    elements.each((_, area) => {
      if ($(area).data('packery')) $(area).packery('destroy')
      $(area).packery({ itemSelector: '.field' })
        .makeDraggable(this.fieldDraggableOptions)
        .off('dragItemPositioned')
        .on('dragItemPositioned', (e, draggedItem) => this.__onItemPositioned(e, draggedItem))
    })
  }

  __initializePackeryOnGroups () {
    if (this.groupsArea.data('packery')) this.groupsArea.packery('destroy')
    this.groupsArea
      .packery({ itemSelector: '.field-group' })
      .makeDraggable(this.groupDraggableOptions)
      .off('dragItemPositioned')
      .on('dragItemPositioned', this.__save.bind(this))
  }

  __onDragEnd (e, _packeryInst, item) {
    $('.draggable-area').removeClass('drag-over')
    const draggabillyInst = $(item.element).data('draggabilly')
    const dragArea = $(draggabillyInst.options.container)
    const dropArea = $(e.target).closest('.draggable-area')

    if (dropArea.is(dragArea)) {
      // common move inside packery instance

    } else if (dropArea.is(this.getFieldsArea())) {
      // Group move (to / from )
      $(item).find('.draggable-item').css({ opacity: 0 })
      dragArea.one('dragItemPositioned', () => this.__forceMoveElements($(item.element), dropArea))
    }
  }

  __onDragMove (e, _packeryInst, item) {
    // const draggabillyInst = item.data('draggabilly')
    // const dragArea = $(draggabillyInst.options.container)
    const dropArea = $(e.target).closest('.draggable-area')

    $('.draggable-area').removeClass('drag-over')
    dropArea.addClass('drag-over')
  }

  __onItemPositioned (e) {
    setTimeout(() => {
      $(e.target).one('layoutComplete', this.__save.bind(this)).packery('layout')
    }, 100)
  }

  __forceMoveElements (elements, dropArea, callback) {
    if (elements.length === 0 && _.isFunction(callback)) return callback()

    const dragArea = elements.closest('.inactive-area, .draggable-area')
    const clone = elements.clone()

    clone.find('.draggable-item').css({ opacity: 1 })
    dragArea.packery('remove', elements).one('removeComplete', () => {
      dragArea.packery('layout')
      dropArea.append(clone).packery('appended', clone).packery('layout').one('layoutComplete', () => {
        const options = clone.is('.field-group') ? this.groupDraggableOptions : this.fieldDraggableOptions

        dropArea.makeDraggable(options)

        if (_.isFunction(callback)) {
          this._updateGroupsVisibility()
          this.groupsArea.data('packery').once('layoutComplete', () => {
            callback(clone)
          })
        }

        this.groupsArea.packery('layout')
      })
    })
  }

  __bindTogglers () {
    // Hide field columns toggler on disabled fields
    $('.inactive-area .contract-field-expand').hide()

    // Toggle field columns number
    $(document).on('click', '.contract-field-expand', (event) => {
      event.preventDefault()

      const toggler = $(event.target)
      const field = toggler.closest('.field')
      const dragArea = $(field).closest('.inactive-area, .draggable-area')
      const increment = parseFloat(toggler.data('increment'))
      const type = field.data('type')

      let columnsNumberCycle
      if (['multiline', 'editor', 'select', 'multiselect'].includes(type)) {
        columnsNumberCycle = [6, 8, 12]
      } else {
        columnsNumberCycle = [4, 6, 8, 12]
      }

      const currentColumnsNumber = $(field).data('columns')
      const currentColumnsIndex = columnsNumberCycle.indexOf(currentColumnsNumber)
      const nextColumnsIndex = (currentColumnsIndex + increment)
      const nextColumnsNumber = columnsNumberCycle[nextColumnsIndex]

      if (nextColumnsNumber) {
        $(field).data('columns', nextColumnsNumber)
        $(field).removeClass('col-sm-' + currentColumnsNumber)
        $(field).addClass('col-sm-' + nextColumnsNumber)

        // disable togglers
        field.find('.contract-field-expand').closest('li').removeClass('disabled')
        if (nextColumnsNumber === _.first(columnsNumberCycle) ||
          nextColumnsNumber === _.last(columnsNumberCycle)) { toggler.closest('li').addClass('disabled') }

        dragArea.one('layoutComplete', () => {
          this.groupsArea.packery('layout')
          this.__save()
        }).packery('layout')
      }
    })

    // Toggle field activity
    $(document).on('change', 'input.contract-field-switch', (event) => {
      const input = $(event.target)

      const active = input.prop('checked')
      const field = input.closest('.field')

      if (field.hasClass('moving')) {
        return
      }

      if (active) {
        $(field).find('.contract-field-expand').show()
        this.__forceMoveElements(field, this.ungroupedFieldsArea, this.__save.bind(this))
      } else {
        $(field).find('.contract-field-expand').hide()
        this.__forceMoveElements(field, this.inactiveFieldsArea, this.__save.bind(this))
      }
    })

    // Toggle group activity
    $(document).on('change', 'input.custom-contract-group-switch', (event) => {
      const input = $(event.target)
      const active = input.prop('checked')
      const group = input.parents('.field-group')

      if (group.hasClass('moving')) {
        return
      }

      if (active) {
        // move group to active area
        this.__forceMoveElements(group, this.groupsArea, (clone) => {
          this.__initializePackeryOnFields(clone.find('.draggable-group-area'))
        })
      } else {
        // move all fields from group to ungrouped active area
        const fields = group.find('.field')

        Array.from(fields).forEach(field => {
          $(field).find('input[name="active"]').prop('checked', false)
          field.querySelector('input[name="active"]').removeAttribute('checked')
        })
        this.__forceMoveElements(fields, this.inactiveFieldsArea)
        this.__forceMoveElements(group, this.inactiveGroupsArea, this.__save.bind(this))
      }
    })
  }

  __sortedPackeryItems (packeryContainer) {
    const result = []

    if (packeryContainer.data('packery') == null) {
      return result
    }

    return packeryContainer.packery('getItemElements').sort((e1, e2) => {
      const e1Position = e1.getBoundingClientRect()
      const e2Position = e2.getBoundingClientRect()

      // eslint-disable-next-line
      if (e1Position.y == e2Position.y) {
        return e1Position.x - e2Position.x
      } else {
        return e1Position.y - e2Position.y
      }
    })
  }

  __save () {
    const entity = this.entity
    const groups = []
    const fields = []

    this.groupsArea.packery('getItemElements').forEach((group) => {
      const groupId = $(group).data('id')
      const draggableArea = $(group).find('.draggable-area')

      groups.push(groupId)

      this.__sortedPackeryItems(draggableArea).forEach((element) => {
        const fieldId = element.id
        const fieldColumns = element.className

        fields.push({ id: fieldId, group_id: groupId, columns: fieldColumns })
      })
    })

    this.__sortedPackeryItems(this.ungroupedFieldsArea).forEach((element) => {
      const fieldId = element.id
      const fieldColumns = element.className

      fields.push({ id: fieldId, columns: fieldColumns })
    })

    // Save full layout
    $.ajax({
      url: '/contract_layout',
      method: 'PUT',
      data: { contract_layout: { entity, groups, fields } },
      dataType: 'script'
    })
    Turbo.cache.clear()
  }

  _updateGroupsVisibility () {
    const inactiveBlock = $('.inactive-area')
    const groups = inactiveBlock[0]
    const fields = inactiveBlock[1]

    const updateHeaderVisibility = (itemsCount, headerId) => {
      const header = document.querySelector(headerId)
      itemsCount === 0 ? header.classList.add('d-none') : header.classList.remove('d-none')
    }

    updateHeaderVisibility(groups.childElementCount, '#inactive_groups_header')
    updateHeaderVisibility(fields.childElementCount, '#inactive_fields_header')
  }
}

$.fn.makeDraggable = function (options) {
  const packeryInst = this.data('packery')

  if (!packeryInst) {
    console.warn('Cannot be draggable! Packery is not initialized on this element.', this)
    return this
  }

  const Draggabilly = require('draggabilly')

  packeryInst.items.forEach((item) => {
    packeryInst.unbindDraggabillyEvents(item)

    const existingDraggabilly = $(item.element).data('draggabilly')
    if (existingDraggabilly) existingDraggabilly.disable()

    const draggableItem = new Draggabilly(item.element, {
      handle: options.handle,
      container: packeryInst.element
    })

    $(item.element).data('draggabilly', draggableItem)

    const events = ['dragStart', 'dragEnd', 'dragMove', 'pointerUp']
    events.forEach((event) => {
      if (options[event]) {
        draggableItem.on(event, (e) => options[event](e, packeryInst, draggableItem))
      }
    })

    packeryInst.bindDraggabillyEvents(draggableItem)
  })

  return this
}
